import { DocumentTemplateType } from './data/interfaces/DocumentTemplate';

// Document Generation Extension Slots
export const DocGenExtensionSlots = {
	CREATE_DOCUMENT_TEMPLATE_DRAWER: 'urn:sfdrawer:docgen:modals:document-template-create',
	CREATE_DOCUMENT_TEMPLATE_MODAL: 'urn:sfmodal:docgen:modals:document-template-create',
	UPLOAD_DOCX_FILE_MODAL: 'urn:sfmodal:docgen:modals:document-template-upload-docx-file',
};

export const AWS_S3_BUCKET = {
	X_AMZ_SERVER_SIDE_ENCRYPTION: 'AES256',
	X_AMZ_ALGORITHM: 'AWS4-HMAC-SHA256',
	SUCCESS_ACTION_STATUS: 200,
};

export const SUPPORTED_FILE_FORMATS = ['pdf'];

export const SUPPORTED_FILE_EXTENSIONS = SUPPORTED_FILE_FORMATS.map(
	format => '.' + format
);

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB

export const PAGE_WIDTH_THRESHOLD = 10;

export const MAX_DESCRIPTION_LENGTH = 560;

export const MAX_NAME_LENGTH = 35;

export enum SIGNATURE_REQUEST_EXPIRATION {
	// Value in days
	MIN = 1,
	MAX = 365,
	DEFAULT = 30,
}

export enum SignatureRequestType {
	Quick = 'quick',
	Customized = 'customized',
}

export enum ShareFileEntities {
	Client = 'Client',
	Employee = 'Employee',
}

export enum DataPreFilledType {
	SourceMapped = 'SourceMapped',
	Manual = 'Manual',
	None = 'None',
}

export enum ComponentInputType {
	Signer = 'SignerFilled',
	System = 'SystemFilled',
	Annotation = 'Annotation',
}

export enum TemplateActionKeys {
	Edit = 'edit',
	SendAsSignatureRequest = 'sendAsSignatureRequest',
	Share = 'share',
	Delete = 'delete',
}

export enum Entitlements {
	SendForSignature = 'sharefile:entitlementdef-send-for-signature',
	CreateDocumentTemplate = 'sharefile:entitlementdef-create-doctemplate',
	CreateEditableTemplate = 'sharefile:entitlementdef-create-editabletemplates',
}

export const enum DocumentMergeAction {
	MergeVariableDataAndGenerateSignerFields = 'MergeVariableDataAndGenerateSignerFields',
	MergeVariableData = 'MergeVariableData',
	GenerateSignerFields = 'GenerateSignerFields',
}

export const ICON_SIZE = 24;

// Document template types with supported file formats

export const DocumentTemplateTypes = {
	Static: {
		name: 'PDF template',
		type: 'Static' as DocumentTemplateType,
		supportedFileExtensions: ['.pdf', '.docx'],
	},
	Dynamic: {
		name: 'Editable Word template',
		type: 'Dynamic' as DocumentTemplateType,
		supportedFileExtensions: ['.docx'],
	},
};

export enum WorkflowType {
	ContentViewer = 'ContentViewer',
	ContextMenu = 'ContextMenu',
}

export const localStorageSignedInOnMSDesktopApp = 'signedInOnMSDesktopApp';
export const sessionStorageApiDomain = 'apiDomain';
export const learnMoreEditingUrl =
	'https://docs.sharefile.com/en-us/sharefile/sharefile-app/sharefile-web/co-editing.html';

export const EditDesktopModalExtensionSlotName =
	'urn:sfmodal:docgen:modals:document-template-edit-desktop-modal';
export const SignIntoShareFileModalExtensionSlotName =
	'urn:sfmodal:docgen:modals:document-template-signin-to-sharefile-modal';
// Extension slots from other pilets
export const ExternalExtensionSlots = {
	ESIGN_PILET_QUICK_SEND_FOR_SIGNATURE:
		'urn:sfdrawer:esign:document-send-signature-request',
};
